import type { ScanNoteVisibility } from '@kaiizen/kai-pro-api';

const SCAN_NOTE_VISIBILITY_LABELS: Record<ScanNoteVisibility, string> = { internal: 'Internal', external: 'External' };

/** A note's visibility, as shown on the note and on a composer's Internal / External picker. */
export const presentScanNoteVisibility = (visibility: ScanNoteVisibility): string => SCAN_NOTE_VISIBILITY_LABELS[visibility];

/** What a note composer's chosen visibility means: who sees the note, and whether it appears on artifacts. */
export const presentScanNoteVisibilityHint = (visibility: ScanNoteVisibility, orgName: string | undefined): string =>
  visibility === 'internal'
    ? `Internal note. Visible to ${orgName?.trim() || 'your team'}. Never appears on artifacts.`
    : 'External note. Visible to the assigned contractor. Appears on artifacts.';
